<template>
    <div>
        <div v-if="listing" class="card mt-3 p-2 mb-4">
            <h3 class="text-base mb-3 mt-1 font-normal">Details</h3>
            <div class="flex flex-wrap ">
                <div class="pairs">
                    <div>
                        <div class="key">MLS #</div>
                        <div class="value " ignore>{{listing.mlsnum||'---'}}</div>
                    </div>
                    <div>
                        <div class="key">Realtor</div>
                        <div class="value " ignore>{{listing.realtor.name}}</div>
                    </div>
                    <div>
                        <div class="key">Tour #</div>
                        <div class="value " ignore>{{listing.homeid}}</div>
                    </div>
                </div>
                <div class="pairs">
                    <div>
                        <div class="key">LeadBee/Ext.</div>
                        <div class="value " ignore>{{listing.links.leadBee.phone||'---'}} ext. {{listing.links.leadBee.extension||'---'}}</div>
                    </div>
                    <div>
                        <div class="key">Shortcode / Keyword</div>
                        <div class="value " ignore>{{listing.links.shortcode.shortcode}} / {{ listing.links.shortcode.keyword}}</div>
                    </div>
                    <div>
                        <div class="key">External URL</div>
                        <div class="value " ignore>{{specurl}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="listing" class="card mt-3 p-2">
            <h3 class="text-base mb-3 mt-1 font-normal">History</h3>

            <div class="pairs flex flex-wrap">

                <div class="w-full md:w-full ">
                    <div class="key">Posted</div>
                    <div class="value " ignore>{{listing.dates.posted}}</div>
                </div>
                <div class="w-full md:w-full">
                    <div class="key">Updated</div>
                    <div class="value " ignore>{{listing.dates.updated}}</div>
                </div>
                <div class="w-full md:w-full">
                    <div class="key">Listed</div>
                    <div class="value " ignore>{{listing.dates.listed}}</div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        details: [],
        listingAgent: '',
        leads: 0
      }
    },
    computed: {
      specurl() {
        let pkg = 'none';
        if (this.listing.externalURL) {
          pkg = this.listing.externalURL;
        } else {
          // Check to see if realtor works for Baird & Warner
          if (this.listing.realtor.companyID == 102855) {
            pkg = this.listing.address.replace(/\s/g, '');
            pkg = pkg.replace(/[^a-zA-Z0-9]/g, '') + '.bairdwarner.info';
          }
        }
        return pkg;
      }
    },
    watch: {
      listing(val) {
        let vm = this;
        this.$http(`/homes/${val.id}/leads?onlyCount=true`).then(response => {
          vm.leads = response.data;
        });
      }
    },
    props: ['listing']
  }
</script>

<style lang="scss">
    /*tailwind @apply isnt loading for the compiler?*/
    .font-weight-bold {
        font-weight: 700;
    }

    .pairs {
        @apply w-full;

        @screen lg {
            @apply w-1/2;
        }

        .key {
            @apply align-top text-sm;

            @screen xs {
                @apply inline-block w-1/2;
            }
        }

        .value {
            @apply font-weight-bold text-sm mb-4;

            @screen xs {
                @apply inline-block w-1/2;
            }
        }
    }

</style>
